module.exports = __webpack_public_path__ + "static/media/zealix-4.76e4bd71.jpg";